var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00007 0.00390625C0.851833 0.00403664 0.706956 0.0480942 0.583741 0.130514C0.460525 0.212934 0.364497 0.33002 0.307786 0.466983C0.251075 0.603946 0.236223 0.754644 0.265108 0.900043C0.293992 1.04544 0.365316 1.17902 0.470073 1.28391L7.47007 8.28391C7.6107 8.42436 7.80132 8.50325 8.00007 8.50325C8.19882 8.50325 8.38945 8.42436 8.53007 8.28391L15.5301 1.28391C15.6348 1.17902 15.7062 1.04544 15.735 0.900043C15.7639 0.754644 15.7491 0.603946 15.6924 0.466983C15.6356 0.33002 15.5396 0.212934 15.4164 0.130514C15.2932 0.0480942 15.1483 0.00403664 15.0001 0.00390625H1.00007Z",
    fill: "#FF2D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.d40c58085a688c4312f6c0d01ee73048.svg";
export { ForwardRef as ReactComponent };